module.exports = __webpack_public_path__ + "static/media/NNPC.145462e1.145462e1.png";